import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Button } from '../../components/UI';
import { Modal } from '../../components/Modal';

const CheckoutError = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Modal
      isOpen={true}
      backdrop={'solid'}
      handleMerlinLogo={true}
      isClosable={false}
      padding={'base'}
    >
      <>
        <div className={'flex flex-col flex-grow-1 justify-center'}>
          <img
            src={`icons/c-warning.svg`}
            alt={'checkout-error'}
            className={'h-32'}
          />
          <h1 className="text-black text-xl font-semibold text-center mt-8">
            {t('checkoutError.title')}
          </h1>
          <p className="mt-4 text-grey-50 text-sm text-center">
            {t('checkoutError.description')}
          </p>
          <div className="mt-12 flex justify-center w-full px-6 items-center">
            <Button
              loading={false}
              type="button"
              variant="primary"
              buttonClass="text-sm font-semibold"
              onClick={() => {
                navigate('/subscriptions');
              }}
            >
              {t('checkoutError.continue')}
            </Button>
          </div>
        </div>
      </>
    </Modal>
  );
};

export default CheckoutError;
